"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const IconButton_1 = require("../IconButton");
const Target_1 = require("../Target");
const PaginationDot = ({ active, onPageChange, page, disabled = false }) => {
    const handleClick = react_1.default.useCallback(() => {
        onPageChange(page);
    }, [onPageChange, page]);
    return (react_1.default.createElement(Target_1.Target, { "aria-selected": active, "aria-label": `Go to page ${page}`, onClick: handleClick, role: "tab", disabled: disabled, sx: Object.assign({ flexShrink: 0, p: 1, 
            // TODO: SPKVX-1472 we don't support all child selectors, though we need to
            // @ts-ignore
            "& > *": {
                backgroundColor: !disabled
                    ? active
                        ? "iconButtonActiveBackgroundColor"
                        : "iconButtonBackgroundColor"
                    : active
                        ? "iconButtonBackgroundColor"
                        : "disabled01"
            } }, (active
            ? {}
            : {
                "&:hover > *": {
                    backgroundColor: !disabled
                        ? "iconButtonHoverBackgroundColor"
                        : undefined
                },
                "&:active > *": {
                    backgroundColor: "iconButtonActiveBackgroundColor"
                },
                "&:focus-visible > *": {
                    borderColor: "iconButtonFocusBorderColor"
                }
            })) },
        react_1.default.createElement(foundations_1.Box, { sx: {
                border: "1px solid transparent",
                borderRadius: "50%",
                height: 3,
                transition: "colorMedium",
                width: 3
            } })));
};
const getNextPrevButtonDisplay = (hidden) => hidden ? "none" : "flex";
const getNextPrevButtonPlaceholder = (hidden) => (hidden ? 25 : 0);
const DottedPagination = ({ continuous, count, handleClickNext, handleClickPrev, handleKeyUp, handlePageChange, hasNext, hasPrev, hideNextPrevButtonsArray, page, disabled }) => {
    return (react_1.default.createElement(foundations_1.Box, { sx: {
            display: "flex",
            alignItems: "center",
            gap: 4
        } },
        react_1.default.createElement(foundations_1.Box, { onKeyUp: handleKeyUp, role: "tablist", sx: {
                display: "flex",
                flex: 1,
                justifyContent: "center",
                listStyle: "none",
                // Match the spacing for the buttons so the
                // dots are centered and don't change position
                minHeight: 10,
                paddingInlineEnd: [
                    getNextPrevButtonPlaceholder(hideNextPrevButtonsArray[0]),
                    getNextPrevButtonPlaceholder(hideNextPrevButtonsArray[1]),
                    getNextPrevButtonPlaceholder(hideNextPrevButtonsArray[2])
                ],
                paddingInlineStart: 25
            } }, new Array(count).fill(null).map((_value, i) => (react_1.default.createElement(foundations_1.Box, { key: i, sx: {
                display: "flex"
            } },
            react_1.default.createElement(PaginationDot, { active: page === i + 1, page: i + 1, onPageChange: handlePageChange, disabled: disabled }))))),
        react_1.default.createElement(foundations_1.Box, { sx: {
                display: [
                    getNextPrevButtonDisplay(hideNextPrevButtonsArray[0]),
                    getNextPrevButtonDisplay(hideNextPrevButtonsArray[1]),
                    getNextPrevButtonDisplay(hideNextPrevButtonsArray[2])
                ],
                flexGrow: 0,
                gap: 2,
                marginInlineStart: "auto"
            } },
            react_1.default.createElement(IconButton_1.IconButton, { "aria-label": "Go to previous page", disabled: disabled || (!hasPrev && !continuous), icon: "caret-left", onClick: handleClickPrev, shape: "square", size: "sm" }),
            react_1.default.createElement(IconButton_1.IconButton, { "aria-label": "Go to next page", disabled: disabled || (!hasNext && !continuous), icon: "caret-right", onClick: handleClickNext, shape: "square", size: "sm" }))));
};
exports.default = DottedPagination;
//# sourceMappingURL=DottedPagination.js.map